import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type PersonModel from 'tio-common/models/person';
import type RecommendationModel from 'tio-common/models/recommendation';
import type StoreService from 'ember-data/store';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';
import type SessionContextService from 'tio-employee/services/session-context';

export default class PslfIndexRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;
  @service declare sessionContext: SessionContextService;
  @service declare store: StoreService;

  async model() {
    const userId = this.sessionContext.user.id;
    const personId = this.sessionContext.user.person.id;

    const [pslfData, loanSummary, person, mostRecentRecQuery] = await Promise.all([
      this.reimaginedData.fetchPslfData(),
      // @ts-expect-error - Ember Data adapter method not typed on MinimumAdapterInterface
      this.store.adapterFor('user').getLoanSummary(userId),
      // @ts-expect-error type models
      this.store.findRecord<PersonModel>('person', personId, {
        include: 'accounts.financial-institution,accounts.loans',
        reload: true,
      }),
      this.store.query<RecommendationModel>('recommendation', {
        filter: {
          user: userId,
          'requesting-app': 'PSLF',
        },
        include: 'user',
        sort: '-created-at',
        page: {
          offset: 0,
          limit: 1,
        },
      }),
    ]);

    return {
      pslfData,
      loanSummary,
      person,
      mostRecentRecommendation: mostRecentRecQuery?.[0],
    };
  }
}
